// action types
export const SEARCH_MOVIE = 'SEARCH_MOVIE'
export const SEARCH_MOVIE_SUCCESS = 'SEARCH_MOVIE_SUCCESS'
export const SEARCH_MOVIE_FAILURE = 'SEARCH_MOVIE_FAILURE'
export const FETCH_MOVIES = 'FETCH_MOVIES'
export const FETCH_MOVIES_SUCCESS = 'FETCH_MOVIES_SUCCESS'
export const FETCH_MOVIES_FAILURE = 'FETCH_MOVIES_FAILURE'
export const RESET_MOVIES = 'RESET_MOVIES'
export const FETCH_MOVIE = 'FETCH_MOVIE'
export const FETCH_MOVIE_SUCCESS = 'FETCH_MOVIE_SUCCESS'
export const FETCH_MOVIE_FAILURE = 'FETCH_MOVIE_FAILURE'
export const FETCH_STAR_SUCCESS = 'FETCH_STAR_SUCCESS'
export const FETCH_STAR_FAILURE = 'FETCH_STAR_FAILURE'
export const FETCH_CASTS = 'FETCH_CASTS'
export const FETCH_CASTS_SUCCESS = 'FETCH_CASTS_SUCCESS'
export const FETCH_CASTS_FAILURE = 'FETCH_CASTS_FAILURE'
export const FETCH_TRAILERS = 'FETCH_TRAILERS'
export const FETCH_TRAILERS_SUCCESS = 'FETCH_TRAILERS_SUCCESS'
export const FETCH_TRAILERS_FAILURE = 'FETCH_TRAILERS_FAILURE'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js